<div [formGroup]="formGroup" style="margin-left: 5%">
    <mat-label>{{ schema.label }}</mat-label>
    <br/>
    <mat-slide-toggle   color="primary"
                      [formControl]="formControl"
                      [required]="schema.obrigatorio" class="switch switch-medium">
    </mat-slide-toggle>
</div>
